// Waar iemand na het inloggen staat: het startscherm, zijn eigen gegevens,
// een organisatie of platformbeheer. Per tabblad bewaard (sessionStorage), zodat
// verversen je op dezelfde plek houdt en een tweede tabblad een andere
// organisatie kan tonen.
//
// Wisselen gaat via herladen. De beheeromgeving is groot en houdt staat bij;
// schoon opnieuw beginnen is betrouwbaarder dan alles terugzetten.

import { adres } from '../router.js';

const CONTEXT = 'tornema_context';
const SIMULATIE = 'tornema_simulatie';

function lees(sleutel) {
  try { return JSON.parse(sessionStorage.getItem(sleutel)); } catch { return null; }
}
function schrijf(sleutel, waarde) {
  try {
    if (waarde == null) sessionStorage.removeItem(sleutel);
    else sessionStorage.setItem(sleutel, JSON.stringify(waarde));
  } catch { /* geen opslag: dan geldt de standaard */ }
}

export const gekozen = () => lees(CONTEXT);

// ctx: { soort: 'start' | 'mijn' | 'org' | 'platform', org?: uuid }
// pagina: de interne naam ('leden', 'platform-dash'); in de adresbalk komt
// het Engelse adres ('members').
//
// Elke keuze is een nieuwe stap in de geschiedenis van de browser, met de
// context erbij. Zo brengt de terugknop je naar waar je was, ook als dat een
// andere organisatie of platformbeheer was.
export function kies(ctx, pagina = '') {
  schrijf(CONTEXT, ctx);
  history.pushState({ tornema: true, ctx }, '', location.pathname + location.search + (pagina ? '#' + adres(pagina) : ''));
  location.reload();
}

// Bij het laden: kwam je hier met de terugknop, dan geldt de context van die
// stap in de geschiedenis, niet de laatst gekozen context.
export function volgGeschiedenis() {
  const h = history.state;
  if (h?.tornema && 'ctx' in h) schrijf(CONTEXT, h.ctx);
}

// Legt de huidige context vast bij de huidige stap, zonder een nieuwe stap.
export function markeer() {
  try { history.replaceState({ ...(history.state || {}), tornema: true, ctx: gekozen() }, '', location.href); } catch { /* geen history */ }
}
export const naarStart = () => kies({ soort: 'start' });

// Bekijk als (alleen platformbeheer): de app toont wat deze rol ziet. De
// database blijft je eigen rechten geven; dit verbergt alleen.
export const simulatie = () => lees(SIMULATIE);
export function zetSimulatie(rol) {
  schrijf(SIMULATIE, rol ? { rol } : null);
  location.reload();
}

export function wis() {
  schrijf(CONTEXT, null);
  schrijf(SIMULATIE, null);
}
